// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
import styled from 'styled-components';
import Button from '../../components/Button';
import Column from '../../components/Column';

const S = {
  RegisterFormContainer: styled.div`
    margin-top: 38px;
    height: 100%;
  `,
  Logo: styled.img`
    height: 16px;
    width: 115px;
  `,
  Container: styled(Column)`
    height: 100%;
    width: 100%;
  `,
  HeaderContainer: styled(Column)`
    align-items: center;
  `,
  Title: styled.div`
    font-weight: 500;
    font-size: 24px;
    line-height: 35px;
    color: #434343;
    margin-top: 15px;
    margin-bottom: 9px;
  `,
  SubTitle: styled.div`
    font-size: 16px;
    line-height: 23px;
    color: #666666;
  `,
  FailedWrapper: styled(Column)`
    width: 100%;
    margin-top: -20px;
    margin-bottom: 0px;
    position: relative;
    justify-content: space-between;
    align-items: center;
  `,
  FailedImg: styled.img`
    width: 220px;
    height: 220px;
  `,
  FailedLoginButton: styled(Button)`
    width: 112px;
    height: 44px;
    background: #FFFFFF;
    border: 1px solid #C9C9C9;
    box-sizing: border-box;
    border-radius: 4px;
    font-size: 18px;
    line-height: 26px;
    text-align: center;
    color: #EF8200;
    &: hover {
      color: white;
    }
  `,
  FailedRetryButton: styled(Button)`
    width: 112px;
    height: 44px;
    font-size: 18px;
    line-height: 26px;
    display: flex;
    align-items: center;
    text-align: center;
    color: #FFFFFF;
    background: #EF8200;
    border-radius: 4px;
    margin-top: 40px;
  `,
  FailedTitle: styled.div`
    font-weight: 500;
    font-size: 24px;
    line-height: 35px;
    color: #434343;
    display: flex;
    align-items: center;
    justify-content: center;
  `,
  FailedDescription: styled.div`
    font-size: 16px;
    line-height: 23px;
    max-width: 233px;
    color: #666666;
    margin-top: 9px;
    align-items: center;
    justify-content: center;
  `,
  FailedDescriptionWrapper: styled.div`
    font-size: 16px;
    line-height: 23px;
    color: #434343;
    display: flex;
    flex-direction: column;
    text-align: center;
    align-items: center;
    justify-content: center;
  `,
  FailedButtonWrapper: styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    width: 244px;
  `,
  Link: styled.a`
    color: #A6A6A6;
    font-weight: inherit;
  `,
};

export { S as default }
